import Title from './Title/Title';
import './TitleBarMobile.css';

const TitleBarMobile = () => {
    return(
        <div className="title-bar-mobile">
            <Title class_name="title-home-mobile"/>
        </div>
    )
}

export default TitleBarMobile;